(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  class StickyAtc {
    constructor(container) {
      this.container = container;
      this.productId = container.dataset.productId;
      this.productHandle = container.dataset.productHandle;
      this.form = container.querySelector('.sticky-atc-form');
      this.variantSelect = container.querySelector('[data-variant-select]');
      this.quantityInput = container.querySelector('[data-quantity-input]');
      this.addToCartBtn = container.querySelector('[data-add-to-cart]');
      this.buttonText = container.querySelector('[data-button-text]');
      this.buttonLoading = container.querySelector('[data-button-loading]');
      this.priceSale = container.querySelector('.sticky-atc-price-sale');
      this.priceCompare = container.querySelector('.sticky-atc-price-compare');
      this.priceRegular = container.querySelector('.sticky-atc-price-regular');
      this.productImage = container.querySelector('.sticky-atc-product-image');
      
      this.init();
    }
    
    init() {
      this.setupEventListeners();
      this.updateVariantData();
    }
    
    setupEventListeners() {
      // Variant select change
      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', (e) => this.onVariantChange(e));
      }
      
      // Quantity controls
      const decrementBtn = this.container.querySelector('[data-quantity-decrement]');
      const incrementBtn = this.container.querySelector('[data-quantity-increment]');
      
      if (decrementBtn) {
        decrementBtn.addEventListener('click', () => this.adjustQuantity(-1));
      }
      
      if (incrementBtn) {
        incrementBtn.addEventListener('click', () => this.adjustQuantity(1));
      }
      
      // Quantity input change
      if (this.quantityInput) {
        this.quantityInput.addEventListener('change', () => this.validateQuantity());
      }
      
      // Form submission
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.onSubmit(e));
      }
    }
    
    onVariantChange(event) {
      const selectedOption = event.target.options[event.target.selectedIndex];
      const variantId = selectedOption.value;
      const price = selectedOption.dataset.price;
      const comparePrice = selectedOption.dataset.comparePrice;
      const isAvailable = selectedOption.dataset.available === 'true';
      const imageUrl = selectedOption.dataset.image;
      
      // Update price display
      this.updatePriceDisplay(price, comparePrice);
      
      // Update image
      if (imageUrl && this.productImage) {
        this.productImage.src = imageUrl;
      }
      
      // Update form hidden fields
      this.form.querySelector('input[name="id"]').value = variantId;
      
      // Update button state
      this.updateButtonState(isAvailable);
      
      // Update variant data attribute
      this.container.dataset.variantId = variantId;
    }
    
    updatePriceDisplay(price, comparePrice) {
      if (comparePrice && comparePrice !== '0') {
        if (this.priceSale) {
          this.priceSale.textContent = price;
          this.priceCompare.textContent = comparePrice;
        }
      } else {
        if (this.priceRegular) {
          this.priceRegular.textContent = price;
        }
      }
    }
    
    updateButtonState(isAvailable) {
      if (!this.addToCartBtn) return;
      
      this.addToCartBtn.disabled = !isAvailable;
      
      if (isAvailable) {
        this.buttonText.textContent = '{{ "products.product.add_to_cart" | t }}';
      } else {
        this.buttonText.textContent = '{{ "products.product.sold_out" | t }}';
      }
    }
    
    adjustQuantity(change) {
      if (!this.quantityInput) return;
      
      const currentValue = parseInt(this.quantityInput.value) || 1;
      const newValue = Math.max(1, currentValue + change);
      
      this.quantityInput.value = newValue;
      this.form.querySelector('input[name="quantity"]').value = newValue;
    }
    
    validateQuantity() {
      if (!this.quantityInput) return;
      
      let value = parseInt(this.quantityInput.value);
      if (isNaN(value) || value < 1) {
        value = 1;
      }
      
      this.quantityInput.value = value;
      this.form.querySelector('input[name="quantity"]').value = value;
    }
    
    updateVariantData() {
      if (this.variantSelect) {
        const selectedOption = this.variantSelect.options[this.variantSelect.selectedIndex];
        const variantId = selectedOption.value;
        this.container.dataset.variantId = variantId;
      }
    }
    
    async onSubmit(event) {
      event.preventDefault();
      
      if (!this.addToCartBtn || this.addToCartBtn.disabled) return;
      
      const variantId = this.form.querySelector('input[name="id"]').value;
      const quantity = this.form.querySelector('input[name="quantity"]').value;
      
      // Show loading state
      this.addToCartBtn.classList.add('loading');
      this.buttonText.classList.add('hidden');
      this.buttonLoading.classList.remove('hidden');
      this.addToCartBtn.disabled = true;
      
      try {
        // AJAX add to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId),
              quantity: parseInt(quantity)
            }]
          })
        });
        
        if (!response.ok) {
          throw new Error('Failed to add item to cart');
        }
        
        const cartData = await response.json();
        
        // Dispatch custom event for cart update
        document.dispatchEvent(new CustomEvent('theme:cart:update', {
          bubbles: true,
          detail: {
            cart: cartData
          }
        }));
        
        // Show success message
        this.showSuccessMessage();
        
        // Update cart count in header (if exists)
        this.updateCartCount(cartData);
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.showErrorMessage();
      } finally {
        // Reset button state
        setTimeout(() => {
          this.addToCartBtn.classList.remove('loading');
          this.buttonText.classList.remove('hidden');
          this.buttonLoading.classList.add('hidden');
          this.addToCartBtn.disabled = false;
        }, 1500);
      }
    }
    
    showSuccessMessage() {
      // Create success message
      const message = document.createElement('div');
      message.className = 'sticky-atc-message sticky-atc-message-success';
      message.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6667 5L7.5 14.1667L3.33333 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{ 'products.product.added_to_cart' | t }}</span>
      `;
      
      this.container.appendChild(message);
      
      // Remove message after 3 seconds
      setTimeout(() => {
        if (message.parentNode) {
          message.classList.add('fade-out');
          setTimeout(() => {
            if (message.parentNode) {
              message.parentNode.removeChild(message);
            }
          }, 300);
        }
      }, 3000);
    }
    
    showErrorMessage() {
      // Create error message
      const message = document.createElement('div');
      message.className = 'sticky-atc-message sticky-atc-message-error';
      message.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 6.66667V10M10 13.3333H10.0083M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Ajouter au panier</span>
      `;
      
      this.container.appendChild(message);
      
      // Remove message after 3 seconds
      setTimeout(() => {
        if (message.parentNode) {
          message.classList.add('fade-out');
          setTimeout(() => {
            if (message.parentNode) {
              message.parentNode.removeChild(message);
            }
          }, 300);
        }
      }, 3000);
    }
    
    updateCartCount(cartData) {
      // Update cart count in header (adjust selector based on your theme)
      const cartCounts = document.querySelectorAll('[data-cart-count]');
      cartCounts.forEach(element => {
        element.textContent = cartData.item_count;
      });
      
      // Dispatch event for other components to update
      document.dispatchEvent(new CustomEvent('cart:update', {
        detail: { cart: cartData }
      }));
    }
  }
  
  // Initialize sticky ATC on page load
  document.addEventListener('DOMContentLoaded', () => {
    const stickyAtcContainers = document.querySelectorAll('.sticky-atc-container');
    stickyAtcContainers.forEach(container => {
      new StickyAtc(container);
    });
  });
  
  // Listen for variant changes from main product form
  document.addEventListener('variant:change', (event) => {
    const stickyAtcContainers = document.querySelectorAll('.sticky-atc-container');
    stickyAtcContainers.forEach(container => {
      const stickyAtc = container.stickyAtc;
      if (stickyAtc && event.detail && event.detail.variant) {
        // Update variant select
        const select = container.querySelector('[data-variant-select]');
        if (select) {
          select.value = event.detail.variant.id;
          select.dispatchEvent(new Event('change'));
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
